import {useEffect, useMemo} from 'react';
import {useDispatch} from 'react-redux';

import {createBlock} from '../../../store/actions/blockActions';
import {convertToBlockEntity} from '../utils';

export function useCreateBlock(content: any, defaultContent: any = null): boolean {
  /*
   * Create a block from the data on init, if no uid is present.
   */
  const dispatch = useDispatch();
  const uid = content.uid;
  const create = useMemo(() => !uid, []);

  useEffect(() => {
    if (!uid) {
      dispatch(createBlock(convertToBlockEntity({
        ...(defaultContent || {}),
        ...content,
      })));
    }
  }, []);

  return create;
}
